var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// Reference: https://github.com/alibaba/formily/blob/formily_next/packages/antd/src/form-item/index.tsx
import { FormItem as FItem } from '@forest/forms';
import { isVoidField } from '@formily/core';
import { connect, mapProps } from '@formily/react';
import { RiQuestionLine } from 'react-icons/ri';
import { FormLayoutShallowContext, useFormLayout } from '../FormLayout';
const useFormItemLayout = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    const layout = useFormLayout();
    const layoutType = (_b = (_a = props.layout) !== null && _a !== void 0 ? _a : layout.layout) !== null && _b !== void 0 ? _b : 'horizontal';
    return Object.assign(Object.assign({}, props), { layout: layoutType, colon: (_c = props.colon) !== null && _c !== void 0 ? _c : layout.colon, labelAlign: layoutType === 'vertical' ? (_d = props.labelAlign) !== null && _d !== void 0 ? _d : 'left' : (_f = (_e = props.labelAlign) !== null && _e !== void 0 ? _e : layout.labelAlign) !== null && _f !== void 0 ? _f : 'right', labelWrap: (_g = props.labelWrap) !== null && _g !== void 0 ? _g : layout.labelWrap, labelWidth: (_h = props.labelWidth) !== null && _h !== void 0 ? _h : layout.labelWidth, wrapperWidth: (_j = props.wrapperWidth) !== null && _j !== void 0 ? _j : layout.wrapperWidth, labelCol: (_k = props.labelCol) !== null && _k !== void 0 ? _k : layout.labelCol, wrapperCol: (_l = props.wrapperCol) !== null && _l !== void 0 ? _l : layout.wrapperCol, wrapperAlign: (_m = props.wrapperAlign) !== null && _m !== void 0 ? _m : layout.wrapperAlign, wrapperWrap: (_o = props.wrapperWrap) !== null && _o !== void 0 ? _o : layout.wrapperWrap, fullness: (_p = props.fullness) !== null && _p !== void 0 ? _p : layout.fullness, size: (_q = props.size) !== null && _q !== void 0 ? _q : layout.size, inset: (_r = props.inset) !== null && _r !== void 0 ? _r : layout.inset, asterisk: props.asterisk, bordered: (_s = props.bordered) !== null && _s !== void 0 ? _s : layout.bordered, feedbackIcon: props.feedbackIcon, feedbackLayout: (_u = (_t = props.feedbackLayout) !== null && _t !== void 0 ? _t : layout.feedbackLayout) !== null && _u !== void 0 ? _u : 'loose', tooltipLayout: (_w = (_v = props.tooltipLayout) !== null && _v !== void 0 ? _v : layout.tooltipLayout) !== null && _w !== void 0 ? _w : 'icon', tooltipIcon: (_y = (_x = props.tooltipIcon) !== null && _x !== void 0 ? _x : layout.tooltipIcon) !== null && _y !== void 0 ? _y : _jsx(RiQuestionLine, {}) });
};
export const BaseItem = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const formLayout = useFormItemLayout(props);
    return (_jsx(FItem, Object.assign({}, formLayout, { children: _jsx(FormLayoutShallowContext.Provider, Object.assign({ value: {} }, { children: children })) })));
};
// 适配
export const FormItem = connect(BaseItem, mapProps((props, field) => {
    if (isVoidField(field))
        return {
            label: field.title || props.label,
            asterisk: props.asterisk,
            extra: props.extra || field.description,
        };
    if (!field)
        return props;
    const takeFeedbackStatus = () => {
        if (field.validating)
            return 'pending';
        return field.decoratorProps.feedbackStatus || field.validateStatus;
    };
    const takeMessage = () => {
        const split = (messages) => {
            return messages.reduce((buf, text, index) => {
                if (!text)
                    return buf;
                return index < messages.length - 1 ? buf.concat([text, ', ']) : buf.concat([text]);
            }, []);
        };
        if (field.validating)
            return;
        if (props.feedbackText)
            return props.feedbackText;
        if (field.selfErrors.length)
            return split(field.selfErrors);
        if (field.selfWarnings.length)
            return split(field.selfWarnings);
        if (field.selfSuccesses.length)
            return split(field.selfSuccesses);
    };
    const takeAsterisk = () => {
        if (field.required && field.pattern !== 'readPretty') {
            return true;
        }
        if ('asterisk' in props) {
            return props.asterisk;
        }
        return false;
    };
    return {
        label: props.label || field.title,
        feedbackStatus: takeFeedbackStatus(),
        feedbackText: takeMessage(),
        asterisk: takeAsterisk(),
        extra: props.extra || field.description,
    };
}));
FormItem.BaseItem = BaseItem;
export default FormItem;
